import React from "react";
import UndoRedo from "../../../../components/ui/undo-redo/UndoRedo";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import { macroStores } from "../../../../stores/export-stores";

function GlobalUndoRedo() {
  const macro = useOpticsStore((state) => state.macro);

  const { canUndo, canRedo, onUndo, onRedo } = macroStores[macro]?.(
    (state) => ({
      canUndo: state.canUndo,
      canRedo: state.canRedo,
      onUndo: state.undo,
      onRedo: state.redo,
    })
  );

  return (
    <UndoRedo
      canRedo={canRedo()}
      canUndo={canUndo()}
      onUndo={() => onUndo()}
      onRedo={() => onRedo()}
    />
  );
}

export default GlobalUndoRedo;
